import React, { useEffect, useState } from 'react'
import { useLocalStorage } from 'hooks/useLocalStorage';
import { v4 as uuid } from 'uuid';

const TodoContext = React.createContext()

function TodoProvider({ children }) {
    const { item: todos, saveItem: saveTodos, loading, error } = useLocalStorage('TODOS_V1', []);


    const [searchValue, setSearchValue] = useState('');
    const [openModal, setOpenModal] = useState(false);
    const [filterValue, setFilterValue] = useState('no');
    const [allTodosCompleted, setAllTodosCompleted] = useState(false);

    const completedTodos = todos.filter(todo => !!todo.completed).length
    const totalTodos = todos.length

    const searchedTodos = todos.filter(todo => {
        return todo.text.toLowerCase().includes(searchValue.toLowerCase())
    })

    const filterTodos = searchedTodos.filter(todo => {
        if (filterValue === 'no') {
            return searchedTodos
        } else {
            return todo.category.toLowerCase().includes(filterValue.toLowerCase())
        }
    })

    const completeTodo = (key) => {
        const TodoIndex = todos.findIndex((todo) => (
            todo.key === key
        ))
        const newTodos = [...todos]
        newTodos[TodoIndex].completed = true
        saveTodos(newTodos)
        if (todos.every(todo => todo.completed)) {
            setAllTodosCompleted(true)
        } else {
            setAllTodosCompleted(false)
        }
    }

    const deleteTodo = (key) => {
        const newTodos = [...todos]
        if (newTodos.length === 1) {
            setAllTodosCompleted(true)
        }
        saveTodos(newTodos.filter(todo => todo.key !== key))
    }
    
    useEffect(() => {
        if (todos.every(todo => todo.completed)) {
            setAllTodosCompleted(true)
        } else {
            setAllTodosCompleted(false)
        }
    },[todos])
    
    const addPomodoroEnd = (key) =>{
        const TodoIndex = todos.findIndex((todo) => (
            todo.key === key
        ))
        const newTodos = [...todos]
        newTodos[TodoIndex].completedPomodoros = newTodos[TodoIndex].totalPomodoros // Change this to make in future the pomodoros end dynamic
        
        if(newTodos[TodoIndex].completedPomodoros === newTodos[TodoIndex].totalPomodoros){
            newTodos[TodoIndex].completed = true
        }
        
        saveTodos(newTodos)

        if (todos.every(todo => todo.completed)) {
            setAllTodosCompleted(true)
        } else {
            setAllTodosCompleted(false)
        }
    }

    const addTodo = (text, category, intensity, totalPomodoros, completedPomodoros) => {
        setAllTodosCompleted(false)
        const newTodos = [...todos]
        newTodos.push(
            {
                key: uuid(),
                text,
                openPomodoroSession: false,
                completed: false,
                category: category,
                intensity: intensity,
                totalPomodoros: totalPomodoros,
                completedPomodoros: completedPomodoros,
            })
        saveTodos(newTodos)
    }



    return (
        <TodoContext.Provider value={{
            todos,
            totalTodos,
            completedTodos,
            searchValue,
            setSearchValue,
            searchedTodos,
            completeTodo,
            deleteTodo,
            loading,
            error,
            openModal,
            setOpenModal,
            addTodo,
            filterTodos,
            setFilterValue,
            filterValue,
            allTodosCompleted,
            addPomodoroEnd,
        }}>
            {children}
        </TodoContext.Provider>
    )
}

export { TodoContext, TodoProvider }